<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div
          class="p-primary align-items-center primary-card-color border-bottom"
        >
          <ul
            class="nav tab-filter-menu d-inline-flex justify-content-flex-end"
          >
            <li
              class="nav-item"
              v-for="(item, index) in userFilterOptions"
              :key="index"
            >
              <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                  filteredData.unread == item.id
                    ? 'active'
                    : index === 0 && filteredData.unread === ''
                    ? 'active'
                    : '',
                ]"
                @click.prevent="getFilterValue(item.id)"
              >
                {{ item.value }}
              </a>
            </li>
          </ul>
          <!-- <div class="float-right">
            <app-search @input="getSearchValue" />
          </div> -->
        </div>
      </div>
    </div>

    <app-table
      :id="tableId"
      :options="options"
      :search="search"
      :card-view="false"
      @action="getListAction"
      :filtered-data="filteredData"
    />
  </div>
</template>

<script>
import * as actions from "../../../../app/Config/ApiUrl";
import { TableHelpers } from "../../../../app/Components/Views/Demo/Tables/mixins/TableHelpers";
import {formatDateToLocal, onlyTime, optional} from "../../../../app/Helpers/Helpers";


export default {
  name: "tab-filter",
  mixins: [TableHelpers],
  props: {
    active: Object,
  },
  data() {
    return {
      filteredData: {
        unread: "",
      },
      search: "",
      tableId: "filter-without-wrapper",
      rowData: {},
      options: {
        // cardView: true,
        // cardViewComponent: "grid-view",
        name: this.$t("tab_filter"),
        url: actions.NOTIFICATIONS,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
            {
                title: this.$t('title'),
                type: 'custom-html',
                key: 'data',
                modifier: (data, rowData) => {
                    return `<span><a class='text-primary' href="#" id="r_${rowData.id}" @click=${this.myFunction_r(rowData.id)}>${data.message.replace(/<[^>]*>/g, '')}</a> <br> 
                    <small class="text-muted">From:  ${optional(rowData.notifier, 'full_name')}</small> <br>
                    <small class="text-muted">${formatDateToLocal(rowData.created_at)} ${onlyTime(rowData.created_at)}</small>
                    </span>`;
                }

            },
            // {
            //     title: this.$t('notification_from'),
            //     type: 'object',
            //     key: 'notifier',
            //     uniqueKey: 'id',
            //     modifier: function (notifier, rowData) {
            //         return optional(notifier, 'full_name');
            //     }
            // },
            // {
            //     title: this.$t('date'),
            //     type: 'custom-html',
            //     key: 'created_at',
            //     uniqueKey: 'id',
            //     modifier: function (created_at, rowData) {
            //         return `<span>${formatDateToLocal(created_at)}</span>`;
            //     }
            // },
            // {
            //     title: this.$t('time'),
            //     type: 'object',
            //     key: 'created_at',
            //     uniqueKey: 'id',
            //     modifier: function (created_at, rowData) {
            //         return onlyTime(created_at)
            //     }
            // },
        ],
        actions: [],
        showFilter: false,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All" },
        { id: "1", value: "Un Read" },
      ],
    };
  },

  created() {
    this.options.columns = [...this.options.columns];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    // getSearchValue(value) {
    //   let instance = this;
    //   this.search = value;
    //   setTimeout(function () {
    //     instance.$hub.$emit("reload-" + instance.tableId);
    //   });
    // },
    getFilterValue(item) {
      this.filteredData.unread = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },
    getListAction(rowData, actionObj, active) {
    },
    myFunction_r(id){
      let doc = document.getElementById('r_'+id);
      if(doc){
          doc.addEventListener('click', () => {
              this.view(id);
          }) 
      }
    },
    view(id) {
        window.location = '/all-notifications?id='+id;
    },
           

    // searchAndSelectFilterOptions() {
    //   this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
    //     let name = this.options.filters.find(
    //       (element) => element.title === this.$t("search_and_select")
    //     );
    //     name.option = response.data.map((name) => {
    //       return {
    //         id: name.name,
    //         value: name.name,
    //       };
    //     });
    //   });
    // },
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
  },
};
</script>
